import { render, staticRenderFns } from "./prescriptionOne.vue?vue&type=template&id=09f7e0ea&scoped=true"
import script from "./prescriptionOne.vue?vue&type=script&lang=ts"
export * from "./prescriptionOne.vue?vue&type=script&lang=ts"
import style0 from "./prescriptionOne.vue?vue&type=style&index=0&id=09f7e0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f7e0ea",
  null
  
)

export default component.exports